'use strict';

const toaster = require('./toaster');
const isSmallView = require('./modules/helpers/isSmallView');
const customSelect = require('./select-custom');

const customerservice = {
    toasterOptions: {},
    init : function() {
        toaster.def.$toasterGeneralEl = $('.js-toaster-container');
        toaster.init();

        const deleleteOption = $('.js-subreasons-privacy').find('[value*="delete"]');
        const franchiseOption = $('.js-subreasons-business').find('[value*="Rituals store"]');

        this.toasterOptions = {
            'Privacy': {
                optiomn2Element: deleleteOption.length ? deleleteOption : $('.js-subreasons-privacy').find('[value*="Delete"]'),
                toasterSelector:  $('.js-contact-privacy-toaster'),
                disableForm: false
            },
            'Business': {
                optiomn2Element: franchiseOption.length ? franchiseOption : $('.js-subreasons-business').find('[value*="franchise"]'),
                toasterSelector:  $('.js-contact-business-toaster'),
                disableForm: true
            }
        };

        $('select[name$="_contactus_reason1"]').on('change', toggleReason2);
        $('select[name$="_contactus_reason2"]').on('change', handleReason2Change);

        $('body').on('click','#sendBtn', function(e){
            if ($(this).data('disabled')){
                e.preventDefault();
                handleReason2Change();
            }
        });

        toggleReason2();
        bindUploadFileCountValidation();
        getFileName();

        $('.js-custom-file-upload').on('keyup', function(e){
            if (e.which == 13) {
                // on enter trigger click function
                $(this).trigger('click');
            }
        });

        $('.js-contact-privacy-toaster .js-accept-contact-form').on('click', function(){
            $('#ContactForm #sendBtn').data('disabled', false);
        });
    }
};

function handleOptionsChoice(reason1Val){
    if (!customerservice.toasterOptions[reason1Val] || !customerservice.toasterOptions[reason1Val].optiomn2Element.is(':selected')){
        $('#dwfrm_contactus_comment').removeAttr('disabled');
        $('#ContactForm #sendBtn').removeAttr('disabled');
        $('#ContactForm #sendBtn').data('disabled', false);
        return;
    }

    toaster.open({
        target: customerservice.toasterOptions[reason1Val].toasterSelector
    });

    $('#dwfrm_contactus_comment').attr('disabled', true);

    if (customerservice.toasterOptions[reason1Val].disableForm){
        $('#ContactForm #sendBtn').attr('disabled', true);
        return;
    }

    $('#ContactForm #sendBtn').data('disabled', true);
    return;
}

function toggleReason2(e) {
    const reasonSelect = e ? $(e.target) : $('select[name$="_contactus_reason1"]');
    const reasonSelected = reasonSelect.val();

    $('.js-subreasons-select-row').hide();
    $('select[name$="_contactus_reason2"]').prop('disabled', true);

    const reasonid = reasonSelect.find(':selected').data('reasonid');

    handleOrderNumberOnReason1Change(reasonid);
    removeErrorMessageForReason1(reasonSelect, reasonid);

    const reason2Select = $('.js-subreasons-' + reasonid);

    if (!reason2Select.length){
        return;
    }
    reason2Select.find('#dwfrm_contactus_reason2').prop('disabled', false);
    reason2Select.show();
    reason2Select.find('.js-hidden-select').addClass('js-custom-select');
    customSelect.init();

    if (!isSmallView()) {
        reason2Select.find('.js-custom-select').attr('tabindex', '-1');
    }

    handleOptionsChoice(reasonSelected);
}

function handleOrderNumberOnReason1Change(reasonid) {
    const $orderNumber = $('input[name$="_contactus_ordernumber"]');
    const $orderNumberRow = $orderNumber.closest('.js-form-row-order-number');

    if (reasonid == 'orderdeliveryreturn' || reasonid == 'productcomplaint') {
        $orderNumber.addClass('required');
        $orderNumberRow.addClass('required');
        $('.optional-indicator', $orderNumberRow).hide();
        return;
    }

    $orderNumberRow.removeClass('required');
    $orderNumber.removeClass('required');
    $('.optional-indicator', $orderNumberRow).show();
    const $errorMessage = $('span[id$="_contactus_ordernumber-error"]', $orderNumberRow);

    if (Resources.VALIDATE_ORDERNUMBER == $errorMessage.text()) {
        return;
    }

    $errorMessage.remove();
    $orderNumber.prop('area-invalid', false);
    $orderNumber.removeClass('error');
    $orderNumber.removeClass('error-text');
    $orderNumber.removeClass('js-validator-error');
}

function removeErrorMessageForReason1(reasonSelect, reasonid) {
    if (!reasonid) {
        return;
    }

    const $reasonRow = reasonSelect.closest('.js-form-row-reason1');
    $('span[id$="_contactus_reason1-error"]', $reasonRow).remove();
    $reasonRow.prop('area-invalid', false);
    $reasonRow.removeClass('error');
    $reasonRow.removeClass('error-text');
    $reasonRow.removeClass('js-validator-error');

}

function handleReason2Change() {
    return handleOptionsChoice($('select[name$="_contactus_reason1"]').val());
}

function bindUploadFileCountValidation() {
    $('#ContactForm').on('submit', function(e) {
        const $fileUpload = $('#attachment').get(0);

        const attachmentCount = parseInt($fileUpload.files.length);

        if (attachmentCount > 0){
            if (attachmentCount > 5) {
                e.preventDefault();
                $('#js-attachment-file-count-error').show();
                return false;
            }

            const allowedExtensions = $('#allowed-extensions').text().split(',');
            for (let index = 0; index < attachmentCount; index++){
                const fileName = $fileUpload.files[index].name;
                const fileExtension = fileName.split('.').pop();

                if (allowedExtensions.indexOf(fileExtension) == -1){
                    $('#js-attachment-file-extension-error').show();
                    return false;
                }
            }

        }

        $('#js-attachment-file-count-error').hide();
        $('#js-attachment-file-extension-error').hide();

        return true;
    });
}

//get and append the name of the uploaded file
function getFileName() {
    $('.js-file-attach').on('change', function(){
        $('.js-contactus-filename').empty();
        this.files.forEach((file) => {
            $('.js-contactus-filename').append(file.name, '&nbsp;');
        });
        if (this.files.length !== 0) {
            $('.js-contactus-nofiles').hide();
            return;
        }
        $('.js-contactus-nofiles').show();
    });
}

module.exports = customerservice;
